import { render, staticRenderFns } from "./editClaimPartyModal.vue?vue&type=template&id=09b0f38a&scoped=true&"
import script from "./editClaimPartyModal.vue?vue&type=script&lang=js&"
export * from "./editClaimPartyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b0f38a",
  null
  
)

export default component.exports